// frontend/src/StoreLocator/StoreLocator.jsx — /store-locator/<tab> and /store-locator/locations/<id>
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { usePinnedHeights } from '../ItAssets/ItAssets';
import { slApi } from './apiClient';
import { TABS } from './common';
import Locations from './Locations';
import LocationPage from './LocationPage';
import SpecialHours from './SpecialHours';
import Notices from './Notices';
import Tags from './Tags';
import Stores from './Stores';

const TAB_IDS = TABS.map(([id]) => id);

export default function StoreLocator() {
  const { tab: tabParam, id } = useParams();
  const navigate = useNavigate();
  const tab = TAB_IDS.includes(tabParam) ? tabParam : 'locations';
  const [meta, setMeta] = useState(null);
  const [toast, setToast] = useState('');
  const notify = useCallback((text) => { setToast(text); setTimeout(() => setToast(''), 2500); }, []);
  const reloadMeta = useCallback(() => slApi.meta().then(setMeta).catch(() => {}), []);
  useEffect(() => { reloadMeta(); }, [reloadMeta]);
  useEffect(() => { if (!tabParam && !id) navigate('/store-locator/locations', { replace: true }); }, [tabParam, id, navigate]);
  const setPage = usePinnedHeights();
  const ctx = { meta, reloadMeta, notify };
  if (id !== undefined || tabParam === 'new') {
    return <LocationPage id={id === undefined ? null : Number(id)} ctx={ctx} />;
  }
  return (
    <section className="uh-page uh-ia-page" ref={setPage}>
      <div className="uh-ia-top">
        <div className="uh-ph">
          <div>
            <h1 className="uh-h1">Store Locator</h1>
            <div className="uh-sub">One list of stores, their hours, special hours and notifications, published as the map, the directory and a page per store on every Soccer Post site.</div>
          </div>
        </div>
        <div className="uh-ia-tabs" role="tablist">
          {TABS.map(([tid, label]) => <Link key={tid} to={`/store-locator/${tid}`} role="tab" aria-selected={tab === tid} className="uh-ia-tab uh-sl-tablink">{label}</Link>)}
        </div>
      </div>
      {tab === 'locations' && <Locations ctx={ctx} />}
      {tab === 'special-hours' && <SpecialHours ctx={ctx} />}
      {tab === 'notices' && <Notices ctx={ctx} />}
      {tab === 'tags' && <Tags ctx={ctx} />}
      {tab === 'stores' && <Stores ctx={ctx} />}
      {toast && <div className="uh-ia-toast" role="status">{toast}</div>}
    </section>
  );
}
